import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, TrendingDownIcon, AlertTriangleIcon, ThumbsUpIcon } from 'lucide-react';
interface InsightCard {
  title: string;
  value: string;
  type: 'neutral' | 'positive' | 'warning';
  icon: React.ElementType;
  targetId?: string;
}
interface AIResponseProps {
  message: string;
  insights?: InsightCard[];
  onInsightClick?: (id: string) => void;
}
export function AIResponse({
  message,
  insights,
  onInsightClick
}: AIResponseProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="flex gap-4 mb-8" data-id="element-51" data-mp="3kxvuoa12axhc">
      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-primary-indigo to-ai-purple flex items-center justify-center shadow-md" data-id="element-52" data-mp="3uo8icb46b6rp">
        <SparklesIcon className="w-5 h-5 text-white" data-id="element-53" data-mp="2x8ululobhkbj" />
      </div>

      <div className="flex-1 min-w-0 space-y-4" data-id="element-54" data-mp="3275uwu6sfqsp">
        <div className="bg-white rounded-2xl rounded-tl-none p-4 shadow-soft border border-slate-100" data-id="element-55" data-mp="325uqcs5iqf0j">
          <p className="text-slate-700 text-[15px] leading-relaxed" data-id="element-56" data-mp="3j1jr6cbptmes">
            {message}
          </p>
        </div>

        {insights && insights.length > 0 && <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-57" data-mp="398b8ovs1z4k7">
            {insights.map((insight, idx) => {
          const Icon = insight.icon;
          const colorClasses = {
            neutral: 'bg-slate-50 border-slate-200 text-slate-700',
            positive: 'bg-success/5 border-success/20 text-success',
            warning: 'bg-warning/5 border-warning/20 text-warning'
          };
          const clickable = Boolean(insight.targetId && onInsightClick);
          return <motion.button key={idx} type="button" disabled={!clickable} onClick={() => clickable && onInsightClick!(insight.targetId!)} initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.2 + idx * 0.1
          }} className={`p-3 rounded-xl border text-left ${colorClasses[insight.type]} flex flex-col gap-1.5 transition-all ${clickable ? 'cursor-pointer hover:shadow-md hover:-translate-y-0.5' : 'cursor-default'}`} data-id="element-58" data-mp="ojon2xc59xal" data-mpi={idx}>
                  <div className="flex items-center gap-1.5 text-[13px] font-medium opacity-80" data-id="element-59" data-mp="2nr5161pg2red">
                    <Icon className="w-3.5 h-3.5" data-id="element-60" data-mp="2rrnslunfdvg1" />
                    {insight.title}
                  </div>
                  <div className="font-display font-bold text-base" data-id="element-61" data-mp="1cb6ug4hqohgb">
                    {insight.value}
                  </div>
                  {clickable && <span className="text-[11px] font-medium opacity-70 mt-auto" data-id="element-62" data-mp="18tivzr27imyt">
                      Tap to view →
                    </span>}
                </motion.button>;
        })}
          </div>}
      </div>
    </motion.div>;
}